import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInspectionSheetPageSetting } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import BackendLayout from "../../layouts/BackendLayout";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { INSPECTION_SHEET, INSPECTION_STATUS } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import {
  ButtonDownloadFile,
  ButtonFilterSearch,
  ButtonHelp,
  PageAlert,
  RadioInput,
  FormGroup,
  Label,
  FormGroupInput,
  ButtonDPad,
  ModalInspection,
  ButtonBack, RedirectAlert,
} from "../../components";
import Select2 from "../../components/Select2";
import { TableHead } from "flowbite-react";
import Table from "../../components/table/Table";
import { range } from "../../utils/array-utils";
import TableBody from "../../components/table/TableBody";
import {
  formatYearMonthInJapaneseText,
  getDaysInMonth,
  formatTime,
  getPreviousMonth,
} from "../../utils/datetime-utils";
import InspectionResultCell from "./InspectionResultCell";
import { InspectionSheetModalHelp } from "../../containers/inspection-sheet";
import { formatOptions } from "../../utils/array-utils";
import {
  getSelectedValue,
  getSelectedGroupValue,
} from "../../utils/select-utils";
import {
  setButtonProcessing,
  clearPageLoading,
  resetAlert,
  clearButtonProcessing,
  setUpdateMachineBatchAlertError,
  setPageLoading,
  setComponentLoading,
  clearComponentLoading,
} from "../../store/actions";
import ScrollModalButtons from "../../components/ScrollModalButtons"
import { filter } from "../../api/inspections/InspectionSheetApi";
import {
  getUrl,
  errorStatusHandle,
  getInputErrorMessage,
  hasErrorInput,
} from "../../utils";
import { API_GET_INSPECTION_SHEET, API_INSPECTION_SHEET_DOWNLOAD } from "../../constants/api";
import _ from "lodash";
import { updateUserSetting } from "../../services/user-master/UserSettingServices";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import { useDocumentTitle } from "../../hooks";
import { useLocation } from "react-router-dom";
import {
  TEPopover,
  TEPopoverContent,
  TEPopoverToggler,
  TERipple,
} from "tw-elements-react";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import InspectionMethodDetails from "./InspectionMethodDetails";
import SheetCell from "./SheetCell";
import { useNavigate } from "react-router-dom";
import {INSPECTION_SHEET_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function InspectionSheet(props) {
  useRedirectPage(INSPECTION_SHEET_PAGE);
  useDocumentTitle("点検表 - 点検王");
  const breadcrumb = getRouteBreadcrumb(INSPECTION_SHEET);
  const [openModalHelp, setOpenModalHelp] = useState(false);
  const inspectionSymbol = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const groupSettings = useSelector((s) => s.app_settings.machine_group);
  const [inputOptions, setInputOptions] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [machines, setMachines] = useState([]);
  const dispatch = useDispatch();
  const [dataSearch, setDataSearch] = useState({
    group_1: "",
    group_2: "",
    group_3: "",
    group_4: "",
    group_5: "",
    machine: "",
    template: "",
    month: "this_month",
  });
  const [errors, setErrors] = useState({});
  const [inspections, setInspections] = useState([]);
  const [inspectionItems, setInspectionItems] = useState([]);
  const [month, setMonth] = useState("");
  const [callApi, setCallApi] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [showInspectModal, setShowInspectModal] = useState(false);
  const [inspectionId, setInspectionId] = useState(null);
  const [workflowId, setWorkflowId] = useState(null);
  const [buttonBack, setButtonBack] = useState(false);

  useEffect(() => {
    dispatch(setPageLoading());
    getInspectionSheetPageSetting().then((pageSettings) => {
      setInputOptions(pageSettings.input_options);
      setTemplates(formatOptions(pageSettings.input_options.templates));
      setMachines(formatOptions(pageSettings.input_options.machines));
      dispatch(setPageSettings(pageSettings));
      dispatch(clearPageLoading());
      if (hasParams()) {
        setCallApi(true);
        return;
      }
      if (pageSettings.user_setting?.setting) {
        setDataSearch(
          handleSetDataSearch(
            pageSettings.user_setting.setting,
            pageSettings.input_options
          )
        );
      }
    });
  }, []);

  const location = useLocation();
  const hasParams = () => {
    if (location?.state?.from === "InspectionStatus") {
      setButtonBack(true);
    }
    const params = new URLSearchParams(location.search);
    if ([...params.entries()].length < 1) {
      return false;
    }
    const machine = params.get("machine") || "";
    const template = params.get("template") || "";
    if (machine !== "" && template !== "") {
      setDataSearch((prevState) => ({
        ...prevState,
        machine: machine || "",
        template: template || "",
        month: params.get("month") || "this_month",
      }));
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (!callApi) {
      return;
    }
    handleSubmitSearch("inspection-sheet-filter-button");
  }, [callApi]);

  useEffect(() => {
    if (templates.length > 1) {
      setHidden(false);
      return;
    }
    let templateValue = "";
    if (templates.length === 1) {
      templateValue = templates[0].value;
    }
    setDataSearch({ ...dataSearch, template: templateValue });
    setHidden(true);
  }, [templates]);

  const handleSetDataSearch = (userSettings, dataOptions) => {
    Object.keys(userSettings).forEach((key) => {
      let optionsKey = "";
      if (key.startsWith("group_")) {
        optionsKey = key;
      }
      if (key === "template" || key === "machine") {
        optionsKey = `${key}s`;
      }
      if (optionsKey !== "" && dataOptions[optionsKey]) {
        const isValidGroupValue = dataOptions[optionsKey].some((option) => {
          const userSettingValue = userSettings[key];

          if (Array.isArray(userSettingValue)) {
            return userSettingValue.includes(option.id);
          }
          return option.id === userSettingValue;
        });
        if (!isValidGroupValue) {
          userSettings[key] = "";
        }
      }
    });
    if (userSettings.template !== "" && userSettings.machine !== "") {
      setCallApi(true);
    }
    getOptionsMachineAndTemplate(userSettings, dataOptions);
    return userSettings;
  };

  const getOptionsForGroup = (groupNumber, parentGroupId) => {
    const groupKey = `group_${groupNumber}`;
    const groupOptions = inputOptions[groupKey] || [];
    const noneOptions = [{ value: "", label: "[ALL]" }];

    if (allGroupIsEmpty(dataSearch)) {
      const allOptions = groupOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));
      return noneOptions.concat(uniqueNameGroupOptions(allOptions));
    }

    if (!parentGroupId) {
      if (groupNumber <= firstGroupNumberNonEmpty()) {
        const allOptions = groupOptions.map((option) => ({
          value: option.id,
          label: option.name,
        }));
        return noneOptions.concat(uniqueNameGroupOptions(allOptions));
      }
      return noneOptions;
    } else {
      const hasManyParentGroupId = Array.isArray(parentGroupId);
      let filteredOptions;
      if (hasManyParentGroupId) {
        filteredOptions = groupOptions.filter((option) =>
          parentGroupId.includes(option.parent_group_id)
        );
      } else {
        filteredOptions = groupOptions.filter(
          (option) => option.parent_group_id === parentGroupId
        );
      }
      const formatOptions = filteredOptions.map((option) => ({
        value: option.id,
        label: option.name,
      }));
      return noneOptions.concat(uniqueNameGroupOptions(formatOptions));
    }
  };

  const allGroupIsEmpty = (data) => {
    return Object.keys(data)
      .filter((key) => key.startsWith("group_"))
      .every((key) => data[key] === "");
  };

  const uniqueNameGroupOptions = (options) => {
    const seenLabels = {};
    return options.reduce((result, { value, label }) => {
      const normalizedLabel = label.toUpperCase();
      if (!seenLabels[normalizedLabel]) {
        seenLabels[normalizedLabel] = value;
        result.push({ value, label });
      } else {
        if (typeof seenLabels[normalizedLabel] === "number") {
          seenLabels[normalizedLabel] = [seenLabels[normalizedLabel], value];
        } else {
          seenLabels[normalizedLabel].push(value);
        }
        result.find(
          (opt) => opt.label.toUpperCase() === normalizedLabel
        ).value = seenLabels[normalizedLabel];
      }
      return result;
    }, []);
  };

  const firstGroupNumberNonEmpty = () => {
    return (
      Object.entries(dataSearch)
        .find(([key, value]) => key.startsWith("group_") && value !== "")?.[0]
        ?.replace("group_", "") || -1
    );
  };

  const handleSelectChange = async (key, selectedValue) => {
    let newSearchData = { ...dataSearch };
    newSearchData[key] = selectedValue;
    if (key.startsWith("group_")) {
      const groupNumber = parseInt(key.split("_")[1], 10);
      for (let i = groupNumber + 1; i <= 5; i++) {
        newSearchData[`group_${i}`] = "";
      }
      newSearchData["machine"] = "";
      newSearchData["template"] = "";
    }
    setDataSearch(newSearchData);
    getOptionsMachineAndTemplate(newSearchData, inputOptions);
    setErrors({});
  };

  const getOptionsMachineAndTemplate = (newSearchData, inputOptions) => {
    const templateOptions = inputOptions["templates"] || [];
    const machineOptions = inputOptions["machines"] || [];
    if (allGroupIsEmpty(newSearchData)) {
      setTemplates(formatOptions(templateOptions));
      setMachines(formatOptions(machineOptions));
    } else {
      getTemplateOptions(templateOptions, newSearchData);
      getMachineOptions(machineOptions, newSearchData);
    }
  };

  const getTemplateOptions = (templateOptions, newSearchData) => {
    const filteredTemplates = templateOptions.filter((template) => {
      return Object.keys(newSearchData).every((key) => {
        if (
          key.startsWith("group_") &&
          newSearchData[key] !== "" &&
          template[key] !== null
        ) {
          if (Array.isArray(newSearchData[key])) {
            return newSearchData[key].includes(template[key]);
          } else {
            return newSearchData[key] === template[key];
          }
        }
        return true;
      });
    });
    setTemplates(formatOptions(filteredTemplates));
  };

  const getMachineOptions = (machineOptions, newSearchData) => {
    const filteredMachines = machineOptions.filter((machine) => {
      return Object.keys(newSearchData).every((key) => {
        if (
          key.startsWith("group_") &&
          newSearchData[key] !== "" &&
          machine["group_relation"][`${key}_id`] !== null
        ) {
          if (Array.isArray(newSearchData[key])) {
            return newSearchData[key].includes(
              machine["group_relation"][`${key}_id`]
            );
          } else {
            return (
              newSearchData[key] === machine["group_relation"][`${key}_id`]
            );
          }
        }
        return true;
      });
    });
    setMachines(formatOptions(filteredMachines));
  };

  const handleSubmitSearch = (buttonId) => {
    if (callApi) {
      setCallApi(false);
    }
    dispatch(resetAlert());
    setErrors({});
    if (!isExistTemplateValue()) {
      return;
    }
    dispatch(setComponentLoading("inspection-sheet"));
    dispatch(setButtonProcessing(buttonId));
    filter(getUrl(dataSearch, API_GET_INSPECTION_SHEET))
      .then((response) => {
        updateSettings();
        const today = new Date();
        const dates = getDaysInMonth(
          today.getFullYear(),
          today.getMonth() + 1,
          dataSearch.month === "last_month"
        );
        setMonth(dataSearch.month);
        setWorkflowId(response.data.workflow.id);
        setInspectionItems(response.data.inspection_items);
        const inspections = range(1, dates).map((day) => {
          let result = _.find(response.data.inspections, {
            inspection_day: day,
          });
          if (
            result === undefined &&
            (day < today.getDate() || dataSearch.month === "last_month")
          ) {
            result = null;
          }
          return result;
        });
        setInspections(inspections);
        setFiltered(true);
      })
      .catch((error) => {
        setFiltered(false);
        setInspectionItems([]);
        setInspections([]);
        errorStatusHandle(error);
        if (error.status === 400) {
          let response = error.data;
          dispatch(setUpdateMachineBatchAlertError(response));
          if (!_.isEmpty(response.errors)) {
            setErrors(response.errors);
          }
        }
      })
      .finally(() => {
        dispatch(clearButtonProcessing(buttonId));
        dispatch(clearComponentLoading("inspection-sheet"));
      });
  };

  const isExistTemplateValue = () => {
    if (hidden && dataSearch["template"] === "") {
      if (dataSearch["machine"] === "") {
        const errors = {
          error_message:
            "入力に問題があります。もう一度確認して入力してください。",
          errors: {
            machine: ["設備No.が未選択です。"],
          },
        };
        dispatch(setUpdateMachineBatchAlertError(errors));
        setErrors(errors.errors);
        setFiltered(false);
      } else {
        setInspectionItems([]);
        setInspections([]);
        setFiltered(true);
      }
      return false;
    }
    return true;
  };

  const updateSettings = async () => {
    const formUserSettings = {
      group_1: dataSearch.group_1,
      group_2: dataSearch.group_2,
      group_3: dataSearch.group_3,
      group_4: dataSearch.group_4,
      group_5: dataSearch.group_5,
      template: parseInt(dataSearch.template),
      machine: parseInt(dataSearch.machine),
      month: dataSearch.month,
    };
    try {
      await updateUserSetting(
        formUserSettings,
        USER_SETTING_CATEGORIES.INSPECTION_SHEET
      );
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleCloseModal = () => {
    setInspectionId(null);
  };

  const sliceUserName = (userName) => {
    if (!_.isEmpty(userName)) {
      return userName.length > 4 ? userName.slice(0, 4) : userName;
    }
    return "-";
  };

  const navigate = useNavigate();
  const redirectInspectionStatus = () => {
    navigate(INSPECTION_STATUS);
  };

  return (
    <BackendLayout sidebar={true} breadcrumb={breadcrumb}>
      <PageTitle title="点検表" />
      <RedirectAlert />
      <PageAlert />
      <ButtonDPad />
      <div className="w-full relative">
        <div className="w-fit">
          <form className="flex flex-row items-start gap-[20px] w-full pt-[15px] pb-1 px-[18px] bg-white md:mr-2.5 xl:mr-[22px] border border-tenken-gray-300 rounded-lg">
            {range(1, 5).map((level) => {
              if (groupSettings[`group_${level}`]?.active) {
                const parentGroupId =
                  level > 1 ? dataSearch[`group_${level - 1}`] : null;
                const options = getOptionsForGroup(level, parentGroupId);
                return (
                  <FormGroup key={level} className="w-fit" direction="vertical">
                    <Label className="mb-[14px] whitespace-nowrap">
                      {groupSettings[`group_${level}`]?.name}
                    </Label>
                    <FormGroupInput
                      error={getInputErrorMessage(errors, `group_${level}`)}
                    >
                      <Select2
                        options={options}
                        value={getSelectedGroupValue(
                          options,
                          dataSearch[`group_${level}`]
                        )}
                        className="min-w-[140px] lg:min-w-[160px] w-full lg:max-w-[240px] max-w-[228px]"
                        classNamePrefix="react-select"
                        maxLength={40}
                        name={`group_${level}`}
                        onChange={(option) =>
                          handleSelectChange(`group_${level}`, option.value)
                        }
                        autoFocus={level === 1}
                      />
                    </FormGroupInput>
                  </FormGroup>
                );
              }
              return null;
            })}
            <FormGroup className="w-fit" direction="vertical">
              <Label className="mb-[14px] whitespace-nowrap">
                {groupSettings["machine"].name}
              </Label>
              <FormGroupInput>
                <Select2
                  options={machines}
                  value={getSelectedValue(machines, dataSearch["machine"])}
                  onChange={(option) =>
                    handleSelectChange("machine", option.value)
                  }
                  placeholder=""
                  className="w-full lg:min-w-[160px] min-w-[140px] lg:max-w-[240px] max-w-[228px]"
                  classNamePrefix="react-select"
                  name="machine"
                  maxLength={200}
                  hasError={hasErrorInput(errors, "machine")}
                />
              </FormGroupInput>
            </FormGroup>
            {!hidden && (
              <FormGroup className="" direction="vertical">
                <Label className="mb-[14px]">点検テンプレート名</Label>
                <FormGroupInput>
                  <Select2
                    options={templates}
                    value={getSelectedValue(templates, dataSearch["template"])}
                    onChange={(option) =>
                      handleSelectChange("template", option.value)
                    }
                    placeholder=""
                    className="w-[200px]"
                    classNamePrefix="react-select"
                    name="template"
                    maxLength={50}
                    hasError={hasErrorInput(errors, "template")}
                  />
                </FormGroupInput>
              </FormGroup>
            )}
            <FormGroup className="" direction="vertical">
              <Label className="whitespace-nowrap">表示対象</Label>
              <FormGroupInput>
                <div className="mt-[4px]">
                  <div>
                    <RadioInput
                      id="last_month"
                      className="small-type"
                      isSmall={true}
                      label="先月"
                      value="last_month"
                      onChange={(e) => {
                        setDataSearch({
                          ...dataSearch,
                          month: e.target.value,
                        });
                      }}
                      checked={dataSearch.month === "last_month"}
                    />
                  </div>
                  <div className="mt-[4px]">
                    <RadioInput
                      id="this_month"
                      className="small-type"
                      isSmall={true}
                      label="今月"
                      checked={dataSearch.month === "this_month"}
                      value="this_month"
                      onChange={(e) => {
                        setDataSearch({
                          ...dataSearch,
                          month: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </FormGroupInput>
            </FormGroup>
            <div className="flex flex-col">
              <div className="h-8"></div>
              <ButtonFilterSearch
                onClick={() =>
                  handleSubmitSearch("inspection-sheet-filter-button")
                }
                className="mt-[10px]"
                id="inspection-sheet-filter-button"
                text="検索実行"
              />
            </div>
          </form>
        </div>
      </div>
      {filtered && inspectionItems.length > 0 ? (
        <>
          <div className="flex flex-row gap-[20px] items-start mt-[24px]">
            <label className="lg:text-[26px] text-2xl font-bold">
              {formatYearMonthInJapaneseText(
                month === "this_month" ? new Date() : getPreviousMonth()
              )}
            </label>
            <ButtonHelp
              color="reset"
              className="px-8"
              onClick={() => setOpenModalHelp(true)}
            >
              凡例
            </ButtonHelp>
            <ButtonDownloadFile
              id="download-inspection-sheet"
              url={API_INSPECTION_SHEET_DOWNLOAD}
              params={dataSearch}
            ></ButtonDownloadFile>
          </div>
          <div className="w-fit pr-7 pb-4">
            <div className="mt-[24px] relative w-fit">
              <LoadingSpinner component="inspection-sheet" />
              <Table>
                <TableHead className="bg-tenken-gray-300">
                  <Table.HeadCell className="group-first/head:first:rounded-none border border-tenken-gray-500 normal-case lg:p-2 p-2 text-center font-normal whitespace-nowrap">
                    <span>No.</span>
                  </Table.HeadCell>
                  <Table.HeadCell className="border border-tenken-gray-500 normal-case lg:p-2 p-2 font-normal whitespace-nowrap">
                    <span>点検項目</span>
                  </Table.HeadCell>
                  <Table.HeadCell className="border border-tenken-gray-500 normal-case lg:p-2 p-2 font-normal whitespace-nowrap">
                    <span>判定基準</span>
                  </Table.HeadCell>
                  {inspections.map((item, day) => (
                    <Table.HeadCell
                      className={`text-center border border-tenken-gray-500 whitespace-nowrap normal-case lg:p-2 p-2 font-normal ${
                        _.isNil(item) ? "min-w-[40px]" : "min-w-[80px]"
                      }`}
                      key={day}
                    >
                      {day + 1}
                    </Table.HeadCell>
                  ))}
                </TableHead>
                <TableBody className="bg-white">
                  {inspectionItems.map((item, idx) => (
                    <Table.Row>
                      <Table.Cell className="border border-tenken-gray-500 lg:p-2 p-2 text-center whitespace-nowrap">
                        {item.item_order}
                      </Table.Cell>
                      <Table.Cell className="border border-tenken-gray-500 lg:p-2 p-2 whitespace-nowrap">
                        <span
                          className="inline-block bread-words"
                          style={{ color: item.title_color }}
                        >
                          {item.title}
                        </span>
                      </Table.Cell>
                      <Table.Cell className="border border-tenken-gray-500 lg:p-2 p-2 whitespace-nowrap">
                        <span
                          className="inline-block bread-words"
                          style={{ color: item.description_color }}
                        >
                          {item.description}
                        </span>
                      </Table.Cell>
                      {inspections.map((inspection, day) => {
                        let filteredItem = {};
                        if (inspection !== null && inspection !== undefined) {
                          filteredItem = inspection.inspection.items.find(
                            (ii) =>
                              ii.inspection_item.item_order === item.item_order
                          );
                        }
                        return (
                          <>
                            {inspection === null ? (
                              <SheetCell key={day}>
                                <InspectionResultCell />
                              </SheetCell>
                            ) : inspection === undefined ? (
                              <SheetCell key={day}></SheetCell>
                            ) : (
                              <SheetCell key={day}>
                                <InspectionResultCell
                                  inspection={inspection}
                                  result={filteredItem?.result}
                                  openModal={showInspectModal}
                                  setOpenModal={setShowInspectModal}
                                  setInspectionId={setInspectionId}
                                />
                              </SheetCell>
                            )}
                          </>
                        );
                      })}
                    </Table.Row>
                  ))}
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      className="text-center border border-tenken-gray-500 lg:p-2 p-2"
                    >
                      点検開始日時
                    </Table.Cell>
                    {inspections.map((inspection, day) => (
                      <SheetCell key={day} className="p-1">
                        {inspection === null || inspection === undefined
                          ? ""
                          : formatTime(
                              inspection?.inspection?.inspection_start_datetime
                            )}
                      </SheetCell>
                    ))}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      className="text-center border border-tenken-gray-500 lg:p-2 p-2"
                    >
                      点検開始担当者
                    </Table.Cell>
                    {inspections.map((inspection, day) => (
                      <SheetCell
                        key={day}
                        className={`${
                          inspection?.inspection?.inspection_start_user &&
                          "hover:cursor-pointer hover:bg-[#feec88]"
                        }`}
                      >
                        <div className="flex justify-center">
                          <TEPopover
                            trigger="focus"
                            className="lg:p-2 p-2 w-fit"
                          >
                            <TERipple rippleColor="white">
                              <TEPopoverToggler tag="span">
                                {inspection === null || inspection === undefined
                                  ? ""
                                  : sliceUserName(
                                      inspection?.inspection
                                        ?.inspection_start_user?.name
                                    )}
                              </TEPopoverToggler>
                            </TERipple>
                            <TEPopoverContent placement="bottom">
                              <div className="px-4 py-2 rounded-lg bg-gray-200 bg-clip-padding border border-gray-300 empty:hidden">
                                <p>
                                  {inspection?.inspection
                                    ?.inspection_start_user &&
                                    inspection?.inspection
                                      ?.inspection_start_user?.name +
                                      " (" +
                                      inspection?.inspection
                                        ?.inspection_start_user?.username +
                                      ")"}
                                </p>
                              </div>
                            </TEPopoverContent>
                          </TEPopover>
                        </div>
                      </SheetCell>
                    ))}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      className="text-center border border-tenken-gray-500 lg:p-2 p-2"
                    >
                      稼働開始日時
                    </Table.Cell>
                    {inspections.map((inspection, day) => (
                      <SheetCell key={day} className="p-1">
                        {inspection === null || inspection === undefined
                          ? ""
                          : formatTime(
                              inspection?.inspection?.operation_start_datetime
                            )}
                      </SheetCell>
                    ))}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      className="text-center border border-tenken-gray-500 lg:p-2 p-2"
                    >
                      稼働開始担当者
                    </Table.Cell>
                    {inspections.map((inspection, day) => (
                      <SheetCell
                        key={day}
                        className={`${
                          inspection?.inspection?.operation_start_user &&
                          "hover:cursor-pointer hover:bg-[#feec88]"
                        }`}
                      >
                        <div className="flex justify-center">
                          <TEPopover
                            trigger="focus"
                            className="lg:p-2 p-2 w-fit"
                          >
                            <TERipple rippleColor="white">
                              <TEPopoverToggler tag="span">
                                {inspection === null || inspection === undefined
                                  ? ""
                                  : sliceUserName(
                                      inspection?.inspection
                                        ?.operation_start_user?.name
                                    )}
                              </TEPopoverToggler>
                            </TERipple>
                            {inspection?.inspection?.operation_start_user
                              ?.name !== undefined && (
                              <TEPopoverContent placement="bottom">
                                <div className="px-4 py-2 rounded-lg bg-gray-200 bg-clip-padding border border-gray-300 empty:hidden">
                                  <p>
                                    {inspection?.inspection
                                      ?.operation_start_user &&
                                      inspection?.inspection
                                        ?.operation_start_user?.name +
                                        " (" +
                                        inspection?.inspection
                                          ?.operation_start_user?.username +
                                        ")"}
                                  </p>
                                </div>
                              </TEPopoverContent>
                            )}
                          </TEPopover>
                        </div>
                      </SheetCell>
                    ))}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      colSpan={3}
                      className="text-center border border-tenken-gray-500 lg:p-2 p-2"
                    >
                      日常点検＿承認状況
                    </Table.Cell>
                    {inspections.map((inspection, day) => (
                      <SheetCell key={day}>
                        {inspection?.judgment_result ? <DoneSign /> : ""}
                      </SheetCell>
                    ))}
                  </Table.Row>
                </TableBody>
              </Table>
              {/*<InspectionMethodDetails />*/}
            </div>
          </div>
        </>
      ) : filtered && inspectionItems.length === 0 ? (
        <p className="mt-5">
          該当する検索結果が見つかりませんでした。別の検索条件をお試しください。
        </p>
      ) : (
        ""
      )}
      {buttonBack && (
        <div className="w-full flex justify-center">
          <ButtonBack className="mt-5" onClick={redirectInspectionStatus} />
        </div>
      )}
      {showInspectModal && (
        <>
          <ModalInspection
            showModal={showInspectModal}
            setShowModal={setShowInspectModal}
            inspection={inspectionId}
            workflow={workflowId}
            onClose={handleCloseModal}
          />
          <ScrollModalButtons/>
        </>
      )}
      <InspectionSheetModalHelp
        openModal={openModalHelp}
        setOpenModal={setOpenModalHelp}
        inspectionSymbol={inspectionSymbol}
      />
    </BackendLayout>
  );
}

const DoneSign = () => {
  return (
    <div className="w-full flex items-center justify-center">
      <div className="flex items-center justify-center w-[30px] h-[30px] border-2 border-red-600 rounded-full text-red-500 font-bold">
        済
      </div>
    </div>
  );
};
